var map = {
	"./AmChart/BarChart": 18,
	"./AmChart/BarChart.js": 18,
	"./AmChart/LineChart": 19,
	"./AmChart/LineChart.js": 19,
	"./AmChart/PieChart": 20,
	"./AmChart/PieChart.js": 20,
	"./Avatar/Avatar": 21,
	"./Avatar/Avatar.css": 23,
	"./Avatar/Avatar.js": 21,
	"./Avatar/bot.svg": 90,
	"./CategoryCard/SupportCategoryCard": 24,
	"./CategoryCard/SupportCategoryCard.css": 26,
	"./CategoryCard/SupportCategoryCard.js": 24,
	"./CategoryCard/faq_icon.png": 93,
	"./ChatMsg/ChatMsg.css": 11,
	"./ChatMsg/PlainTextChatMsg": 27,
	"./ChatMsg/PlainTextChatMsg.js": 27,
	"./ChatMsg/TextWithLinkChatMsg": 30,
	"./ChatMsg/TextWithLinkChatMsg.js": 30,
	"./ChatMsg/bot.svg": 94,
	"./ChatMsgWrapper/ChatMsgWrapper.css": 31,
	"./ChatMsgWrapper/PlainTextWrapper": 32,
	"./ChatMsgWrapper/PlainTextWrapper.js": 32,
	"./ChatWindow/ChatWindow.css": 13,
	"./ChatWindow/SampleChatWindow": 33,
	"./ChatWindow/SampleChatWindow.js": 33,
	"./ChatWindow/SampleChatWindowWithCategories": 36,
	"./ChatWindow/SampleChatWindowWithCategories.js": 36,
	"./ChatWindow/analytics_icon.png": 110,
	"./ChatWindow/bot.svg": 109,
	"./ChatWindow/faq_icon.png": 111,
	"./Header/HeaderWithBackIcon": 37,
	"./Header/HeaderWithBackIcon.js": 37,
	"./Header/HeaderWithDockedState": 38,
	"./Header/HeaderWithDockedState.js": 38,
	"./Loader/CustomLoader": 39,
	"./Loader/CustomLoader.css": 40,
	"./Loader/CustomLoader.js": 39,
	"./Loader/DefaultLoader": 41,
	"./Loader/DefaultLoader.js": 41,
	"./PlainText/PlainText": 42,
	"./PlainText/PlainText.js": 42,
	"./TextInputForm/SampleTextInputForm": 43,
	"./TextInputForm/SampleTextInputForm.js": 43,
	"./TextWithLink/SampleTextWithLink": 44,
	"./TextWithLink/SampleTextWithLink.js": 44,
	"./Timestamp/DefaultFormatTimestamp": 45,
	"./Timestamp/DefaultFormatTimestamp.js": 45
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;


//////////////////
// WEBPACK FOOTER
// ./src/docs/examples ^\.\/.*$
// module id = 80
// module chunks = 0